export default "__VITE_ASSET__ybr5gfYX__"